import React from 'react';

import { ReactQueryProvider as ReactQueryProviderOriginal } from '@gogame/query';
import { useScreenMessage } from '@gogame/screens';

export const ReactQueryProvider = ({ children }) => {
  const { showErrorMessage, showSuccessMessage, showMessage } =
    useScreenMessage();

  return (
    <ReactQueryProviderOriginal
      showSuccessMessage={showSuccessMessage}
      showErrorMessage={showErrorMessage}
      showMessage={showMessage}
    >
      {children}
    </ReactQueryProviderOriginal>
  );
};
